import React from 'react';
import { useDispatch } from 'react-redux';
import ServicesContext from '../../contexts/ServicesContext';
import { MainActions } from '../../actions/MainActions';
import { FrontVersion, FrontVersionResources } from '../../models/FrontVersion';
import {
  Container,
  WarningContainer, WarningHeader, WarningMessage,
  AlertContainer, AlertHeader, AlertMessage,
  CurrentVersionContainer, CurrentVersionName, CurrentVersionNumberName
} from './styles';

interface IFrontVersionDisplayProps {
}

const FrontVersionDisplay: React.FC<IFrontVersionDisplayProps> = ({
}) => {

  const dispatch = useDispatch();
  const mainActions = React.useMemo(() => new MainActions(dispatch), [dispatch]);

  const [loading, setLoading] = React.useState<boolean>(true);
  const [versions, setVersions] = React.useState<FrontVersion[]>([]);
  const [currentVersion, setCurrentVersion] = React.useState<FrontVersion | null | undefined>(null);
  const [nextMandatoryVersions, setNextMandatoryVersions] = React.useState<FrontVersion[]>([]);

  const currentFrontVersionNumber = FrontVersionResources.currentNumber;

  const {
    getAllFrontVersionsService,
    alertService
  } = React.useContext(ServicesContext);

  React.useEffect(() => {
    getAllFrontVersionsAndPerformValidation();
  }, []);

  const versionDisplay = React.useMemo(() => {
    if (loading) return null;

    if (nextMandatoryVersions.length > 0) {
      return (
        <WarningContainer>
          <WarningHeader>Atenção!</WarningHeader>
          <WarningMessage>Este dispositivo está usando uma versão depreciada do Sislog.
            <i> Limpe o cache </i> para usar a versão mais recente e <u>evitar problemas</u>.</WarningMessage>
        </WarningContainer>
      );
    }

    const numberOfNextVersions = versions.filter(fv => fv.active && fv.number > currentFrontVersionNumber).length;
    if (numberOfNextVersions > 0) {
      return (
        <AlertContainer>
          <AlertHeader>Observação!</AlertHeader>
          <AlertMessage>Este dispositivo não está usando a versão mais recente do Sislog.
            <i> Limpe o cache </i> para usar a versão mais recente.</AlertMessage>
        </AlertContainer>
      );
    }

    return (
      <CurrentVersionContainer>
        <CurrentVersionName>Versão</CurrentVersionName>
        <CurrentVersionNumberName>{currentVersion?.numberName || currentFrontVersionNumber}</CurrentVersionNumberName>
      </CurrentVersionContainer>
    );
  }, [versions, currentVersion, nextMandatoryVersions, loading]);

  return (
    <Container>
      {versionDisplay}
    </Container>
  );

  function getAllFrontVersionsAndPerformValidation() {
    mainActions.setNotWait(true);
    getAllFrontVersionsService.handle()
      .then(result => {
        const list = result?.value?.list || [];
        setVersions(list);
        setCurrentVersion(list.find(fv => fv.number === currentFrontVersionNumber));
        const mandatoryVersions = list.filter(fv => fv.active && fv.number > currentFrontVersionNumber && fv.mandatory);
        setNextMandatoryVersions(mandatoryVersions);
        showAlert(mandatoryVersions);
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => mainActions.setNotWait(false), 1000);
      });
  }

  function showAlert(mandatoryVersions: FrontVersion[]) {
    const numberOfMandatoryVersions = mandatoryVersions.length;

    if (numberOfMandatoryVersions === 0) return;

    alertService.warningHtml('Este dispositivo está usando uma versão não recomendada do Sislog.' +
      '<i> Limpe o cache </i> para usar a versão mais recente e <u>evitar problemas</u>.');
  }

}

export { FrontVersionDisplay };